<div class="place-spinner">
    <div class="ring-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>